export type System = "water" | "transport" | "power";
export type ZoneId =
  | "beacon"
  | "cathedral"
  | "stowe"
  | "centre"
  | "city"
  | "trent";
export type ScenarioId = "calm" | "storm" | "rail" | "energy";
export interface Parameters {
  rain: number;
  wind: number;
  disruption: number;
  demand: number;
}
export interface Zone {
  id: ZoneId;
  name: string;
  short: string;
  coordinates: [number, number];
  households: number;
  floodExposure: number;
  transportExposure: number;
  powerExposure: number;
  description: string;
  type: string;
}
export interface Decision {
  id: string;
  minute: number;
  zone: ZoneId;
  system: System;
  delta: 1 | -1;
}
export type Allocation = Record<ZoneId, Record<System, number>>;
export interface ZoneState {
  id: ZoneId;
  water: number;
  transport: number;
  power: number;
  affected: number;
  continuity: number;
}
export interface Incident {
  id: string;
  zone: ZoneId;
  system: System;
  severity: number;
  title: string;
  crews: number;
  activeCrews: number;
}
export interface Snapshot {
  minute: number;
  zones: ZoneState[];
  incidents: Incident[];
  continuity: number;
  mobility: number;
  energy: number;
  affected: number;
  disruptionHours: number;
  allocations: Allocation;
}
export interface Run {
  parameters: Parameters;
  decisions: Decision[];
  scenario: ScenarioId;
  minute: number;
}
export const SYSTEMS: System[] = ["water", "transport", "power"];
export const RESOURCE_LIMIT = 8;
export const DURATION = 120;
export const STEP = 5;
